import { Component, Input } from '@angular/core';

@Component({
    selector: '[piLogo]',
    template: `
        <svg
            class="clickable pi-logo"
            [attr.width]="piLogo.width"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 321.83 321.83"
            title="PI SVG Logo"
        >
            <svg:path
                d="M270.68,233.87a3.57,3.57,0,0,0-.82.08v1.83h.7c.82,0,1.48-.27,1.48-.93S271.62,233.87,270.68,233.87Z"
            />
            <svg:path
                d="M160.91,0A160.91,160.91,0,1,0,321.83,160.91,160.91,160.91,0,0,0,160.91,0Zm37.75,81.2.75-1.35h57.73l1.61,13.52-2,.7a98.41,98.41,0,0,1-17,3.71v41.75a23.26,23.26,0,0,0-24.66.38V97.66l-17-3.21-.55-1.29c-.4-.92-.54-2.33-.54-5.37A15.23,15.23,0,0,1,198.66,81.2Zm44.65,78.44a15.56,15.56,0,1,1-15.56-15.56A15.55,15.55,0,0,1,243.31,159.64ZM128.88,187.71a156.52,156.52,0,0,1-24.23-2.16v38.68c2,.21,4.37.44,6.86.68,5.91.56,12.6,1.2,16.33,1.89l1.81.33.31,1.81a33.39,33.39,0,0,1,0,10.86l-.38,2.19h-67l-.94-15.27,2.25-.46c4-.81,8.11-1.22,12.13-1.63,1.32-.13,2.6-.26,3.86-.4v-127c-5.29-.7-10.22-1.43-15.37-2.56l-1.94-.42-.13-2a29.4,29.4,0,0,1,1.41-10.57l.56-1.88h66.64c19.34,0,32.49,3.44,41.4,10.82,9.71,8,14.43,21,14.43,39.7C186.88,171.09,170.08,187.71,128.88,187.71Zm129.74,52.92-.75,1.36h-61l-1.42-14.2,2-.68c5.2-1.8,11.85-2.6,17.72-3.31V179.38a23.27,23.27,0,0,0,24.66.37v44.18l19.38,3.54.56,1.3a11.87,11.87,0,0,1,.54,4.39A19.66,19.66,0,0,1,258.63,240.62Zm12.21,1.89a6.42,6.42,0,1,1,0-12.85,6.42,6.42,0,1,1,0,12.85Z"
            />
            <svg:path
                d="M119.69,98.52c-1.24,0-2.5,0-3.81,0l-11.49.18v70.75l14.63.83c2.11.12,4.16.18,6.09.18h0c14.54,0,23.79-3.36,29.13-10.57,4.64-6.28,6.63-15.47,6.63-30.75C160.86,108.34,156.8,98.52,119.69,98.52Z"
            />
            <svg:path
                d="M270.84,231a5.1,5.1,0,0,0,0,10.2,4.89,4.89,0,0,0,4.87-5.06A4.94,4.94,0,0,0,270.84,231Zm1.52,8.45a5.45,5.45,0,0,1-.51-1.56c-.12-.7-.51-1-1.32-1h-.7v2.57h-1.48V233a12.94,12.94,0,0,1,2.45-.19,4,4,0,0,1,2.22.47,1.77,1.77,0,0,1,.62,1.4,1.64,1.64,0,0,1-1.32,1.48v.08a1.88,1.88,0,0,1,1.17,1.56,4.86,4.86,0,0,0,.47,1.6Z"
            />
        </svg>
    `,
    standalone: false
})
export class LogoSVGComponent {
    @Input()
    piLogo: any;
}
